module.exports = __webpack_public_path__ + "static/assets/c31200cb6dd3458f2d50905a13e9c9a5.svg";